import AppRoute from "models/AppRoute"
import { ValuationStatus } from "models/Valuation"


interface IValuationsRouteParams {
    status?: ValuationStatus
}
const ValuationsRoute = new AppRoute<IValuationsRouteParams>({
    route: "/valuation",
    navbar: true,
    authRequired: true,
})

export default ValuationsRoute
